import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightCircle } from 'lucide-react';
import '../../assets/styles/Home.css';
import { useLanguage } from '../../assets/js/LanguageContext';

const BACKGROUND_VIDEO = `${process.env.PUBLIC_URL}/emociones-home.mp4`;

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  }),
};

const Home_0 = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <video
        className="hero-video"
        src={BACKGROUND_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      />

      <div className="hero-content">
        <div className="hero-inner">
          <motion.h1
            className="hero-heading"
            custom={0}
            variants={fadeUp}
            initial="hidden"
            animate="visible"
          >
            {t('home0_title')}
          </motion.h1>

          <motion.p
            className="hero-subtext"
            custom={1}
            variants={fadeUp}
            initial="hidden"
            animate="visible"
          >
            {t('home0_subtitle')}
          </motion.p>

          <motion.div
            className="hero-actions"
            custom={2}
            variants={fadeUp}
            initial="hidden"
            animate="visible"
          >
            <motion.a
              href="/sign-up"
              className="cta"
              whileHover={{ scale: 1.04, filter: 'brightness(1.1)' }}
              whileTap={{ scale: 0.96 }}
            >
              {t('home0_try_free')}
              <ArrowRightCircle size={20} aria-hidden="true" />
            </motion.a>

            <a href="/pricing" className="cta cta--secondary">
              {t('home0_cta_pricing')}
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Home_0;
